function SvgComponent(props: any) {

    return (
        <svg
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M18.75 9.75a6.75 6.75 0 00-13.5 0c0 2.769 2.215 6.378 6.75 10.701 4.535-4.323 6.75-7.932 6.75-10.701zM12 22.5c-5.5-5-8.25-9.25-8.25-12.75a8.25 8.25 0 1116.5 0c0 3.5-2.75 7.75-8.25 12.75z"
            fill={props.isSelected ? "#5627FF" : "#000"}
        />
        <path
            d="M12 12a2.25 2.25 0 100-4.5 2.25 2.25 0 000 4.5zm0 1.5A3.75 3.75 0 1112 6a3.75 3.75 0 010 7.5z"
            fill={props.isSelected ? "#5627FF" : "#000"}
        />
        </svg>
    )
}
  
  export default SvgComponent